import { render, staticRenderFns } from "./copyPermission.vue?vue&type=template&id=7d57d7ee&scoped=true"
import script from "./copyPermission.vue?vue&type=script&lang=js"
export * from "./copyPermission.vue?vue&type=script&lang=js"
import style0 from "./copyPermission.vue?vue&type=style&index=0&id=7d57d7ee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d57d7ee",
  null
  
)

export default component.exports